/**
 * @generated SignedSource<<6abf0af72f0cdadd4a47fdc1274b8847>>
 * @relayHash cce4e0522a0bbf89aa28f9e4da5d7beb
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cce4e0522a0bbf89aa28f9e4da5d7beb

import type { ConcreteRequest } from 'relay-runtime';
export type RemoveLabelsFromLabelableInput = {
  clientMutationId?: string | null | undefined;
  labelIds: ReadonlyArray<string>;
  labelableId: string;
};
export type removeLabelsFromLabelableMutation$variables = {
  input: RemoveLabelsFromLabelableInput;
};
export type removeLabelsFromLabelableMutation$data = {
  readonly removeLabelsFromLabelable: {
    readonly clientMutationId: string | null | undefined;
  } | null | undefined;
};
export type removeLabelsFromLabelableMutation$rawResponse = {
  readonly removeLabelsFromLabelable: {
    readonly clientMutationId: string | null | undefined;
  } | null | undefined;
};
export type removeLabelsFromLabelableMutation = {
  rawResponse: removeLabelsFromLabelableMutation$rawResponse;
  response: removeLabelsFromLabelableMutation$data;
  variables: removeLabelsFromLabelableMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RemoveLabelsFromLabelablePayload",
    "kind": "LinkedField",
    "name": "removeLabelsFromLabelable",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "removeLabelsFromLabelableMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "removeLabelsFromLabelableMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "cce4e0522a0bbf89aa28f9e4da5d7beb",
    "metadata": {},
    "name": "removeLabelsFromLabelableMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "9f3ee532d3745a09f037181e4a226f48";

export default node;
